import { FC } from 'react'

import { GreyGrey100, TextAreaField } from '@sequencehq/core-components'

import { PUBLISH_MODAL_COPY } from './PublishQuoteModalV2.constants'

type Props = {
  approvalComment: string
  setApprovalComment: (value: string) => void
  'data-testid': string
}

export const ApprovalFields: FC<Props> = ({
  approvalComment,
  setApprovalComment,
  'data-testid': dataTestId
}) => {
  return (
    <TextAreaField
      data-testid={dataTestId}
      placeholder={PUBLISH_MODAL_COPY.approvalRequired.messagePlaceholder}
      value={approvalComment}
      label={PUBLISH_MODAL_COPY.approvalRequired.messageLabel}
      onChange={value => setApprovalComment(value)}
      minHeight="100px"
      styles={{
        label: {
          color: GreyGrey100
        }
      }}
    />
  )
}
